import { defineStore } from "pinia";

export const useAdminUiStore = defineStore("adminUi", {
  state: () => ({
    sidebarOpen: true,
    isPinned: false
  }),

  actions: {
    toggleSidebar() {
      if (!this.isPinned) {
        this.sidebarOpen = !this.sidebarOpen;
      }
    },

    togglePin() {
      this.isPinned = !this.isPinned;
      if (this.isPinned) this.sidebarOpen = true;
    }
  }
});
